import React from 'react';
import Chip from '@mui/material/Chip';
import { getColor } from 'src/util/util';
import { resolveTagStyle } from 'src/util/tagChipStyle';

// Shared renderer for the selected tag chips in the family (Tags.jsx) and
// person (PersonTags.jsx) tag autocompletes. Uses the SAME resolveTagStyle as
// the pedigree/family tables so a given tag looks identical in both places
// (e.g. Preclinic = green, Migrated Family = teal). Well-known tags get a fixed
// semantic colour; others use their palette colour (or the getColor pastel
// fallback), rendered adaptively so they stay readable.
export const renderTagChips = (options) => (value, getTagProps) =>
  value.map((option, index) => {
    const label =
      typeof option === 'string' ? option : option?.label ?? option?.inputValue;
    const tagColor =
      options.find((o) => o.label === label)?.tagColor ?? getColor(label);
    // getTagProps supplies `key` + the delete handler; pull key out so it isn't
    // spread into JSX (React warns otherwise).
    const { key, ...tagProps } = getTagProps({ index });
    return (
      <Chip
        key={key}
        label={label}
        size="small"
        {...tagProps}
        style={resolveTagStyle(label, tagColor)}
        // Existing tags were rendering faded — force full opacity even if the
        // autocomplete marks a tag disabled.
        sx={{ fontSize: '0.75rem', '&.Mui-disabled': { opacity: 1 } }}
      />
    );
  });
